import styled, { css } from 'styled-components';

import {
	PRIMARY,
	SECONDARY,
} from 'core/sitecore/experience-editor/ExperienceEditorContent/ExperienceEditorContent.style';
import * as mx from 'core/styles/mixins';

import { PositionType } from './ExperienceEditorMessage';

const DEFUALT_OFFSET = '-10px';

export const Message = styled.div<{
	position: PositionType;
	margin?: string;
}>`
	${mx.circle('22px')}
	background-color: ${PRIMARY};
	color: ${SECONDARY};
	cursor: help;
	display: flex;
	align-items: center;
	justify-content: center;

	${({ margin }) =>
		margin &&
		css`
			margin: ${margin};
		`}

	${({ position }) =>
		position !== 'inline' && position !== 'block'
			? css`
					position: absolute;

					${() => {
						switch (position) {
							case 'top-right':
								return css`
									top: ${DEFUALT_OFFSET};
									right: ${DEFUALT_OFFSET};
								`;
							case 'top-left':
								return css`
									top: ${DEFUALT_OFFSET};
									left: ${DEFUALT_OFFSET};
								`;
							case 'bottom-left':
								return css`
									bottom: ${DEFUALT_OFFSET};
									left: ${DEFUALT_OFFSET};
								`;
							case 'bottom-right':
								return css`
									bottom: ${DEFUALT_OFFSET};
									right: ${DEFUALT_OFFSET};
								`;

							default:
								return css`
									top: ${position?.top};
									right: ${position?.right};
									bottom: ${position?.bottom};
									left: ${position?.left};
								`;
						}
					}}
			  `
			: position === 'inline'
			? css`
					display: inline-flex;
			  `
			: null}
`;
